const RouteFragment = {
    ORGANIZATIONS: "organizations",
    COPY_ORGANIZATION: "copy-organization",
    STORAGE_SERVERS: "storage-servers",
    USERS: "users",
    USER_GROUPS: "user-groups",
    RISKS: "risks",
    RISK_ENTITIES: "risk-entities",
    ALL_CONTROLS: "all_controls",
    CONTROLS: "controls",
    ENTITIES: "entities",
    CONTROL_PROGRAM: "control-program",
    CONTROL_PROGRAMS: "control-programs",
    TESTING_PROGRAMS: "testing-programs",
    CONTROL_RESULTS: "control-results",
    CONTROL_ACTIVITIES: "control-activities",
    FUTURE_CONTROL_RESULTS: "future-control-results",
    PENDING_ACTIVITIES: "pending-activities",
    TESTING_CONTROLS: "testing-controls",
    TESTING_ACTIVITIES: "testing-activities",
    DATASHEET_ASSIGNMENTS: "datasheet-assignments",
    RESOURCE_COUNT: "resource-count",
    SAVED_REPORTS: "saved-reports",
    PUSH_REPORTS: "push-reports",
    REPORTS: "reports",
    RESPONSIBLE: "responsible",
    RECIPIENT: "recipient",
    TAGS: "tags",
    TAG_CATEGORIES: "tag-categories",
    STATS: "stats",
} as const;

export { RouteFragment };
